import { useOutletContext } from 'react-router-dom';
import { FinancialAidCorrectionsSection } from '@triedge/financial-aid-ui/corrections';
import type { FinancialAidStaffDetailContext } from '../ApplicantDetail';

export function CorrectionsTab() {
  const ctx = useOutletContext<FinancialAidStaffDetailContext>();
  return <FinancialAidCorrectionsSection controller={ctx.correctionController} />;
}
